.cell {
  float: left;
  padding: 0.65rem;
}

.packagesList {
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}

.packagesListItem {
  margin: 0;
  padding: 0;
  line-height: 1.2rem;
}

.modal {
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-y: auto;
}

.paper {
  position: relative;
  top: 4rem;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 2px 2px rgba(0, 0, 0, 0.5);
  padding: 1.5rem 2rem 2rem;
  min-width: 300px;
  max-width: 800px;
  width: 100%;
}

.modal {
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-y: auto;
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  font-size: 3rem !important;
  color: #888;
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvZGV2L3NyYy9jYXB0dXJlbGlmZS9yZXBvcy9DYXB0dXJlbGlmZS1hd3MvcHdhL3NyYy9hcHBzL3BvcnRhbC9jb21wb25lbnRzL0pvYkNvbmZpZ3MiLCJzb3VyY2VzIjpbImNsYXNzZXMubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBRUE7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmNlbGwge1xuICBmbG9hdDogbGVmdDtcbiAgcGFkZGluZzogMC42NXJlbTtcbn1cblxuLnBhY2thZ2VzTGlzdCB7XG4gIG1hcmdpbjogMDtcbiAgcGFkZGluZzogMDtcbiAgZm9udC1zaXplOiAwLjhyZW07XG59XG5cbi5wYWNrYWdlc0xpc3RJdGVtIHtcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwO1xuICBsaW5lLWhlaWdodDogMS4ycmVtO1xufVxuXG4ubW9kYWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogc3RhcnQ7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBvdmVyZmxvdy15OiBhdXRvO1xufVxuXG4ucGFwZXIge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHRvcDogNHJlbTtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2ZmZjsvL3RoZW1lLnBhbGV0dGUuYmFja2dyb3VuZC5wYXBlcjtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBib3gtc2hhZG93OiAycHggMnB4IHJnYmEoMCwgMCwgMCwgMC41KTsvL3RoZW1lLnNoYWRvd3NbNV07XG4gIHBhZGRpbmc6IDEuNXJlbSAycmVtIDJyZW07XG4gIC8vcGFkZGluZzogdGhlbWUuc3BhY2luZygyOyAyOyAzKTtcbiAgbWluLXdpZHRoOiAzMDBweDtcbiAgbWF4LXdpZHRoOiA4MDBweDtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5tb2RhbCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBzdGFydDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIG92ZXJmbG93LXk6IGF1dG87XG59XG5cbi5jbG9zZUljb24ge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgcmlnaHQ6IDA7XG4gIHBhZGRpbmc6IDAuNXJlbTtcbiAgZm9udC1zaXplOiAzcmVtICFpbXBvcnRhbnQ7XG4gIGNvbG9yOiAjODg4O1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG4iXX0= */